import { uuidv5 } from '@elfsight/lib-utils';

export type CreatePlaceholderTokenParams = {
  prefix: string;
  value: string;
  suffix?: string;
};

const NON_ALPHANUMERIC_SYMBOLS_REGEXP = /[^a-z0-9]/gi;

export function createPlaceholderToken({
  prefix,
  value,
  suffix = 'X'
}: CreatePlaceholderTokenParams) {
  const rawValue = uuidv5(value, uuidv5.URL);
  const normalizedValue = rawValue.replace(NON_ALPHANUMERIC_SYMBOLS_REGEXP, '');

  return `${prefix}${normalizedValue || '0'}${suffix}`;
}
